import {
    SignupBackgroundLayout,
    TwcOverlayTemplate
} from "@/components/signup/layouts";
import SiteActivation from "@/components/signup/site-activation";
import { TeamworkCollectionLogo } from "@/components/signup/utils";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import {
    CreateAWorkspaceText,
    Headings,
    WorkspacesAreWhereText
} from "../../components";

export const NewUser = () => {
    const twcSignupOverlayEnrolled = checkFeatureFlagGate(
        featureFlags.cfind5480TwcSignupOverlay
    );

    const content = (
        <>
            <Headings
                main={<CreateAWorkspaceText />}
                sub={<WorkspacesAreWhereText />}
            />
            <SiteActivation />
        </>
    );

    if (twcSignupOverlayEnrolled) {
        return <TwcOverlayTemplate size="sm">{content}</TwcOverlayTemplate>;
    }

    return (
        <SignupBackgroundLayout ProductLogo={<TeamworkCollectionLogo />}>
            {content}
        </SignupBackgroundLayout>
    );
};
